import { css } from 'styled-components';

const styles = css`
  .checkmark {
    top: -10px;
    right: -8px;
  }
  .radio-method {
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    border-radius: 6px;
    background-color: ${(props) => props.theme.colorPalette.white};
    label {
      padding-left: 0px;
      text-align: center;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      border: 2px solid ${(props) => props.theme.colorPalette.gray[300]};
    }

    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    }
  }
  .elem-mt-LRG div {
    text-align: left;
    margin-bottom: 10px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-bottom: 20px;
    }
  }
  .ship-option-container {
    display: inline-flex;
    width: ${(props) => (props.shipmentMethodsSize > 2 ? '32%' : '148px')};
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    position: relative;
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: inline-flex;
      width: 188px;
      margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    }

    & label {
      border: 1px solid ${(props) => props.theme.colorPalette.gray[600]};
      border-radius: 8px;
      text-align: center;
    }
    .spinner-style {
      position: absolute;
      top: 25%;
      left: 2%;
      width: 97%;
    }
    .spinner-container {
      background-color: white;
      margin: 2px;
    }
    .spc-spinner {
      width: ${(props) => (props.shipmentMethodsSize > 2 ? '90px' : '133px')};
      height: ${(props) => (props.shipmentMethodsSize > 2 ? '85px' : '80px')};
      left: ${(props) => (props.shipmentMethodsSize > 2 ? '15px' : '25px')};
      @media ${(props) => props.theme.mediaQuery.medium} {
        width: ${(props) => (props.shipmentMethodsSize > 2 ? '150px' : '160px')};
        height: 80px;
        left: 35px;
      }
    }
    .spc-spinner div {
      top: 35px;
      left: 20%;
    }
    .spc-spinner div:nth-child(1) {
      left: 25%;
      animation: quantity-spinner-animation 1.2s infinite;
    }
  }

  .ship-option-container:nth-child(3) {
    margin-right: 0px;
  }

  .ship-option-container.checked {
    width: ${(props) => (props.shipmentMethodsSize > 2 ? '32%' : '148px')};
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 190px;
    }

    & label {
      border: 3px solid ${(props) => props.theme.colorPalette.blue[500]};
      border-radius: 8px;
      box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.12);
    }
  }

  .radio-button-checked {
    height: 100%;
    width: 100%;
    background-color: transparent;
    border-radius: 8px;
    left: 0;
  }

  .ship-option-container .radio-button,
  .ship-option-container .radio-button-checked:after {
    height: 100%;
    width: 100%;
    background-color: transparent;
    align-items: center;
    border-radius: 8px;
    left: 0;
    @media ${(props) => props.theme.mediaQuery.medium} {
      height: 100%;
      width: 100%;
      background-color: transparent;
      align-items: center;
      border-radius: 8px;
      left: 0;
    }
  }

  .ship-option-container .radio-button,
  .ship-option-container .radio-button-checked {
    max-height: 96px;
    border-width: 0px;
  }

  .input-radio-title {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    text-transform: capitalize;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      color: ${(props) => props.theme.colorPalette.gray[900]};
    }
    @media ${(props) => props.theme.mediaQuery.largeOnly} {
      margin: 5px;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      font-size: ${(props) => `${props.theme.fonts.fontSize.body.bodytext.copy3}px`};
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      font-size: ${(props) => `${props.theme.fonts.fontSize.body.bodytext.copy4}px`};
    }
    text-align: center;
  }
  .radio-button-checked + .input-radio-title {
    font-weight: ${(props) => props.theme.typography.fontWeights.bold};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      color: ${(props) => props.theme.colorPalette.gray[900]};
    }
  }
  .input-subtitle {
    display: block;
    text-align: center;
    font-size: ${(props) => `${props.theme.fonts.fontSize.body.bodytext.copy3}px`};
    font-weight: ${(props) => props.theme.typography.fontWeights.bold};
  }

  .estimated-shipping-speed {
    color: ${(props) => props.theme.colorPalette.green[500]};
    padding: 0px;
    margin-bottom: 10px;
  }
  .radio-button-checked:focus-within {
    outline: none;
  }

  .elem-mt-LRG div span {
    color: ${(props) => props.theme.colorPalette.green[500]};
  }

  .estimated-shipping-rate {
    @media ${(props) => props.theme.mediaQuery.medium} {
      justify-content: flex-start;
    }
  }
  .estimated-shipping-size {
    width: 100%;
    background-color: transparent;
    padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
    padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    cursor: default;
    @media ${(props) => props.theme.mediaQuery.medium} {
      text-align: center;
    }
    .radio-button-checked {
      display: none;
    }
  }

  .middle-title {
    font-size: ${(props) => `${props.theme.fonts.fontSize.body.bodytext.copy2}px`};
    padding: 10px 0 10px 0;
    min-height: ${(props) => props.theme.spacing.ELEM_SPACING.MED_1};
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    color: ${(props) => props.theme.colorPalette.green[500]};

    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
      font-size: ${(props) => `${props.theme.fonts.fontSize.body.bodytext.copy3}px`};
    }
  }
`;

export default styles;
